import { render, staticRenderFns } from "./UiKpis.vue?vue&type=template&id=c637090e"
import script from "./UiKpis.vue?vue&type=script&lang=js"
export * from "./UiKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports